module.exports = __webpack_public_path__ + "img/parentskit-logo-2.8535953f.svg";